import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { KoreanPracticeApp } from "./KoreanPracticeApp";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <KoreanPracticeApp />
  </StrictMode>,
);
